<template>
  <div class="substitutoTributario">

    <div class="container">
      <v-snackbar color="warning" v-model="selecioneFiltro" top>
        <span>
          Selecione ao menos UM dos filtros.
        </span>
        <v-btn color="info" @click="selecioneFiltro = false">Fechar</v-btn>
      </v-snackbar>

      <v-snackbar color="error" v-model="erroConsulta" top>
        <span>
          Os dados informados não correspondem a um Substituto Tributário.
        </span>
        <v-btn color="info" @click="erroConsulta = false">Fechar</v-btn>
      </v-snackbar>

      <h1 class="display-1 my-3">Substituto Tributário do ISSQN</h1>

      <v-divider></v-divider>

      <v-row wrap justify="center">
        <v-flex xs12 sm6 xl4>
          <v-card hover class="ma-4">
            <v-card-title>Substituto Tributário</v-card-title>
            <v-card-text>
              <p>
                <span>
                  {{ messageDescritivoSubstitutoTributario }}
                </span>
              </p>

              <v-form ref="form" class="my-3">
                <v-text-field
                    v-mask="['XXX.XXX.XXX-XX', 'XX.XXX.XXX/XXXX-##']"
                    clearable
                    v-model="cpfCnpj"
                    @input="cpfCnpj = cpfCnpj.toUpperCase()"
                    label="CNPJ"
                    prepend-icon="account_circle"
                ></v-text-field>

                <v-text-field
                    clearable
                    v-model="nomeRazaoSocial"
                    label="Nome Empresarial"
                    prepend-icon="description"
                ></v-text-field>

                <!--                <v-text-field-->
                <!--                  clearable-->
                <!--                  v-model="dataInicio"-->
                <!--                  label="Data Início"-->
                <!--                  prepend-icon="location_on"-->
                <!--                ></v-text-field>-->

                <!--                <v-text-field-->
                <!--                  clearable-->
                <!--                  v-model="dataFim"-->
                <!--                  label="Data Fim"-->
                <!--                  prepend-icon="location_on"-->
                <!--                ></v-text-field>-->
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" dark type="submit" @click="pesquisaSubstitutoTributario">
                <v-icon small left>check_circle</v-icon>
                <span>pesquisa</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-row>

      <v-progress-linear class="mt-3" indeterminate :height="12" v-show="loading"></v-progress-linear>

      <v-row class="mt-3">
        <hr class="mt-3">
        <table width="100%" class="tabela">
          <thead align="left">
          <tr>
            <th>
              INSCRIÇÃO MUNICIPAL
            </th>
            <th>
              CNPJ
            </th>
            <th>
              NOME EMPRESARIAL
            </th>
            <th>
              DATA INÍCIO
            </th>
            <!--                    <th>-->
            <!--                        DATA FIM-->
            <!--                    </th>-->
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in listaSubstituto"
              v-bind:key="item.cpfCnpj"
          >
            <td>
              {{ item.inscricaoMunicipal }}
            </td>
            <td>
              {{ formataCpfCnpj(item.cpfCnpj) }}
            </td>
            <td>
              {{ item.razaoSocial }}
            </td>
            <td>
              {{ item.dataInicio }}
            </td>
            <!--                <td>-->
            <!--                    {{ item.dataFim}}-->
            <!--                </td>-->
          </tr>
          </tbody>
        </table>
      </v-row>
    </div>
  </div>
</template>

<script>
// import { httpNF } from "../axios.config";
import {mask} from "vue-the-mask";
import EventService from "../services/EventService";
// import swal from "sweetalert";

export default {
  directives: {mask},
  data() {
    return {
      loading: false,
      cpfCnpj: undefined,
      nomeRazaoSocial: undefined,
      dataInicio: undefined,
      dataDim: undefined,
      regrasObrigacao: [(v) => !!v || "Campo obrigatório!"],
      erroConsulta: false,
      selecioneFiltro: false,
      listaSubstituto: undefined,
      messageDescritivoSubstitutoTributario: ""
    };
  },
  methods: {
    pesquisaSubstitutoTributario() {
      this.loading = true

      if (this.cpfCnpj)
        this.cpfCnpj = this.removeMask(this.cpfCnpj);


      if (this.$refs.form.validate()) {
        this.$httpNF("substitutoTributario", {
          method: "GET",
          responseType: "json",
          headers: {
            // multiTenantId: 2,
            cpfCnpj: this.cpfCnpj || "",
            nomeRazaoSocial: this.nomeRazaoSocial || "",
            // dataInicio: this.dataInicio,
            // dataFim: this.dataFim,
          },
        }).then((res) => {
          this.loading = false
          this.listaSubstituto = res.data;

          if (!this.listaSubstituto.length)
            this.erroConsulta = true;

        }).catch((error) => {
          this.selecioneFiltro = true;
          this.loading = false;
        });
      } else {
        this.selecioneFiltro = true;
      }
    },
    removeMask(mask) {
      return mask.replace(/[^a-zA-Z0-9]/g, "");
    },
    formataCpfCnpj(cpfCnpj) {
      if (cpfCnpj.length <= 11) {
        return this.mascaraCpf(this.removeMask(cpfCnpj))
      } else {
        return this.mascaraCnpj(this.removeMask(cpfCnpj))
      }
    },
    mascaraCpf(cpf) {
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4")
    },
    mascaraCnpj(cnpj) {
      return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "$1.$2.$3/$4-$5");
    }
  },
  created() {
    EventService
        .getBundle("message.portalDescritivoSubstitutoTributario")
        .then(response => this.messageDescritivoSubstitutoTributario = response.data);
  },
};
</script>

<style scoped>
table tr td, th {
  padding: 4px;
  position: relative;
  clear: both;
  border: 1px solid #ddd;
  border-radius: 4px;
  -webkit-border-radius: 4px;
}

th {
  background-color: lightgray;
}

</style>
